import React, { useReducer } from "react";
import { VendorContext } from "./VendorContext";
import { VendorReducer } from "./VendorReducer";
import { VENDOR } from "../../types";
import { baseUrl } from "../../config/config";
import { useMsal } from "@azure/msal-react";

const VendorState = (props) => {
  const { accounts } = useMsal();
  const initialState = {
    //Enrollment
    activeStep: 0,
    steps: [],
    vendFlowEnrollment: {
      id: "",
      guiD_VEND: "",
      state: 0,
      activE_STEP: -1,
      lasT_STEP: -1,
      datE_CREATED: "",
    },
    vendorInformation: {
      id: "",
      ruc: "",
      email: "",
      datE_CREATE: "",
      contact: [
        {
          guid: "",
          type: 0,
          datE_CREATE: "",
        },
      ],
      country: "",
      type: "",
      guiD_PRIMARY_CONTACT: "",
      state: false,
      statemenT_DATE: "",
      statemenT_NAME: "",
      statemenT_PLACE: "",
      statemenT_POSITION_COMPANY: "",
      statemenT_GENERATED: false,
      signaturE_SEND: false,
      company: "",
    },
    companyInformation: {
      id: "",
      businesS_NAME: "",
      ruc: "",
      fundatioN_YEAR: "2020",
      email: "",
      nuM_EMPLOYEES: "",
      urL_SITE: "",
      guid: "",
    },
    vendDocumentation: {
      id: "",
      guiD_VEND: "",
      banK_ID: "",
      entitY_ID: "",
      cedula: "",
      cedulA_RZ: "",
      obligacioneS_IESS: "",
      obligacioneS_IESS_RZ: "",
      registrO_UNICO: "",
      registrO_UNICO_RZ: "",
      referenciA_CLIENTES: "",
      referenciA_CLIENTES_RZ: "",
      certificadO_BANCARIO: "",
      declaracioN_IMP_RENTA: "",
      declaracioN_IVA: "",
      datE_CREATED: "",
      nombramientO_REPRESENTANTE_LEGAL: "",
      nombramientO_REPRESENTANTE_LEGAL_RZ: "",
      informE_RESPONSABILIDAD_SOCIAL: "",
      visioN_MISION_VALORES: "",
      estandareS_ETICOS: "",
      declaracion: "",
      afiliacioN_IESS_CONTACTO: "",
    },
    logisticsPostalAddress: {
      id: "",
      address: "",
      province: "",
      city: "",
      postaL_CODE: "",
      entitY_ID: "",
      reC_ID: 0,
      party: "",
    },
    logisticsPostalAddressBank: {
      id: "",
      address: "",
      province: "",
      city: "",
      postaL_CODE: "",
      entitY_ID: "",
      reC_ID: 0,
      party: "",
    },
    contactPerson: [],
    contactPersonBank: {},
    vendBankAccount: {
      id: "",
      namE_OWNER: "",
      identification: "",
      namE_BANK: "",
      nuM_ACCOUNT: "",
      typE_ACCOUNT: "",
      guiD_VEND: "",
      swifT_CODE: "",
      foreigN_SWIFT_CODE: "",
    },
    bankInformationList: [],
    vendGeneralInformation: {
      id: "",
      guiD_VEND: "",
      diferenT_NAME: "",
      ruc: "",
      tO_DATE: "",
      questioN0: "",
      questioN0_DESCRIPTION: "",
      questioN0_RESP: "",
      questioN1: "",
      questioN1_DESCRIPTION: "",
      questioN1_RESP: "",
      questioN2: "",
      questioN2_DESCRIPTION: "",
      questioN2_RESP: "",
      questioN3: "",
      questioN3_DESCRIPTION: "",
      questioN3_RESP: "",
      questioN4: "",
      questioN4_DESCRIPTION: "",
      questioN4_RESP: "",
      questioN5: "",
      questioN5_DESCRIPTION: "",
      questioN5_RESP: "",
      questioN6: "",
      questioN6_DESCRIPTION: "",
      questioN6_RESP: "",
      questioN7: "",
      questioN7_DESCRIPTION: "",
      questioN7_RESP: "",
      questioN8: "",
      questioN8_DESCRIPTION: "",
      questioN8_RESP: "",
    },
    companyOwner: [],
    contractor: [],
    listCountry: [],
    listProvince: [],
    listCity: [],
    listBank: [],
    listTypeContact: [],
    currentContact: null,
    //calification
  };

  const [state, dispatch] = useReducer(VendorReducer, initialState);

  const setActiveStep = async (data) => {
    dispatch({
      type: VENDOR.ACTIVE_STEP,
      payload: data,
    });
  };
  const setContactPerson = async (data) => {
    dispatch({
      type: VENDOR.CONTACT_PERSON,
      payload: data,
    });
  };
  const setContactPersonBank = async (data) => {
    dispatch({
      type: VENDOR.CONTACT_PERSON_BANK,
      payload: data,
    });
  };
  const setBankInformationList = async (data) => {
    dispatch({
      type: VENDOR.BANK_INFORMATION_LIST,
      payload: data,
    });
  };
  const setVendFlowEnrollment = async (data) => {
    dispatch({
      type: VENDOR.VEND_FLOW_ENROLLMENT,
      payload: data,
    });
  };
  const setVendorInformation = async (data) => {
    dispatch({
      type: VENDOR.VEND_INFORMATION,
      payload: data,
    });
  };
  const setCompanyInformation = async (data) => {
    dispatch({
      type: VENDOR.COMPANY_INFORMATION,
      payload: data,
    });
  };
  const setLogisticsPostalAddress = async (data) => {
    dispatch({
      type: VENDOR.LOGISTICS_POSTAL_ADDRESS,
      payload: data,
    });
  };
  const setVendDocumentation = async (data) => {
    dispatch({
      type: VENDOR.VEND_DOCUMENTATION,
      payload: data,
    });
  };
  const setVendBankAccount = async (data) => {
    dispatch({
      type: VENDOR.VEND_BANK_ACCOUNT,
      payload: data,
    });
  };
  const setVendGeneralInformation = async (data) => {
    dispatch({
      type: VENDOR.VEND_GENERAL_INFORMATION,
      payload: data,
    });
  };
  const setCompanyOwner = async (data) => {
    dispatch({
      type: VENDOR.COMPANY_OWNER,
      payload: data,
    });
  };
  const setContractor = async (data) => {
    dispatch({
      type: VENDOR.CONTRACTOR,
      payload: data,
    });
  };
  const sendVendFlowEnrollment = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendFlowEnrollment/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const respVI = await response.json();
      dispatch({
        type: VENDOR.VEND_FLOW_ENROLLMENT,
        payload: respVI,
      });
    }
  };
  const sendVendorInformation = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendorInformation/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const respVI = await response.json();
      dispatch({
        type: VENDOR.VEND_INFORMATION,
        payload: respVI,
      });
    }
  };
  const sendVendorInformationStatement = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendorInformation/GeneratePDF";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const respVI = await response.json();
      dispatch({
        type: VENDOR.VEND_INFORMATION,
        payload: respVI,
      });
    }
  };
  const sendCompanyInformation = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/CompanyInformation/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.COMPANY_INFORMATION,
        payload: resp,
      });
    }
  };
  const sendVendBankAccount = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendBankAccount/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.VEND_BANK_ACCOUNT,
        payload: resp,
      });
    }
  };
  const sendVendDocumentationAX = async (data, vendorInfor) => {
    const postData = data;
    const localUrl =
      baseUrl +
      "/api/VendDocumentation/UpdateAX?vendAccount=" +
      vendorInfor.ruc +
      "&company=" +
      vendorInfor.company;
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.VEND_DOCUMENTATION,
        payload: resp,
      });
      return true;
    }
    return false;
  };
  const sendVendDocumentation = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendDocumentation/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.VEND_DOCUMENTATION,
        payload: resp,
      });
      return true;
    }
    return false;
  };
  const sendContactPerson = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/ContactPerson/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    const resp = await iFunctionGetContactPerson(postData.entitY_ID);
    dispatch({
      type: VENDOR.CONTACT_PERSON,
      payload: resp,
    });
  };
  const sendVendGeneralInformation = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendGeneralInformation/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.VEND_GENERAL_INFORMATION,
        payload: resp,
      });
    }
  };
  const sendCompanyOwner = async (data) => {
    const postData = data;
    let localUrl = baseUrl + "/api/CompanyOwner/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    // si no existe devuelve response.status === 204
    if (response.status === 200) {
      const guid = accounts[0].localAccountId;
      localUrl = baseUrl + "/api/CompanyOwner?guidPrimaryContact=" + guid;
      const response2 = await fetch(localUrl);
      if (response2.status === 200) {
        const data2 = await response2.json();
        dispatch({
          type: VENDOR.COMPANY_OWNER,
          payload: data2,
        });
      }
    }
  };
  const sendContractor = async (data) => {
    const postData = data;
    let localUrl = baseUrl + "/api/Contractor/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    // si no existe devuelve response.status === 204
    if (response.status === 200) {
      const guid = accounts[0].localAccountId;
      localUrl = baseUrl + "/api/Contractor?guidPrimaryContact=" + guid;
      const response2 = await fetch(localUrl);
      if (response2.status === 200) {
        const data2 = await response2.json();
        dispatch({
          type: VENDOR.CONTRACTOR,
          payload: data2,
        });
      }
    }
  };
  const sendLogisticsPostalAddress = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/LogisticsPostalAddress/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: VENDOR.LOGISTICS_POSTAL_ADDRESS,
        payload: resp,
      });
    }
  };
  const getSteps = async (id) => {
    id = state.vendorInformation.type;
    const steps = [
      "companyInformation",
      "bankInformation",
      "generalInformation",
      "financialLegalInformation",
      "declaration",
      "finished",
    ];

    let data = steps;
    dispatch({
      type: VENDOR.STEPS,
      payload: data,
    });
  };
  const getVendFlowEnrollment = async () => {
    const guid = accounts[0].localAccountId;
    const localUrl =
      baseUrl + "/api/VendFlowEnrollment/GetByGuid?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      await setActiveStep(data.lasT_STEP);
      dispatch({
        type: VENDOR.VEND_FLOW_ENROLLMENT,
        payload: data,
      });
    }
  };
  const getDataEnrollment = async (company) => {
    const guid = accounts[0].localAccountId;
    const localUrl =
      baseUrl + "/api/VendorInformation/GetByGuid?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.VEND_INFORMATION,
        payload: data,
      });
    }
    if (response.status === 204) {
      const localUrl =
        baseUrl +
        "/api/VendorInformation/CreateVend?guidPrimaryContact=" +
        guid +
        "&company=" +
        company +
        "&email=" +
        accounts[0].username;
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      //si no existe devuelve response.status === 204
      if (response.status === 200) {
        const data = await response.json();
        dispatch({
          type: VENDOR.VEND_INFORMATION,
          payload: data,
        });
      }
    }
  };
  const getCompanyInformation = async () => {
    const guid = accounts[0].localAccountId;
    let localUrl =
      baseUrl + "/api/CompanyInformation/GetByGuid?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      const respDoc = await iFunctionGetVendDocumentation(data.id);
      const respCont = await iFunctionGetContactPerson(data.id);
      const respLogis = await iFunctionLogisticsPostalAddress(data.id);
      const respTypeContact = await iFunctionGetListTypeContact();

      const dataDis = {
        company: data,
        document: respDoc,
        listTypeContact: respTypeContact,
        contactPerson: respCont,
        logisticsPostalAddress: respLogis,
      };
      dispatch({
        type: VENDOR.VEND_FULL_COMPANY,
        payload: dataDis,
      });
    } else if (response.status === 204) {
      const dataComp = {
        businesS_NAME: "",
        ruc: "",
        fundatioN_YEAR: "" + new Date().getFullYear(),
        email: "",
        nuM_EMPLOYEES: "",
        urL_SITE: "",
        guid: guid,
      };
      localUrl = baseUrl + "/api/CompanyInformation/Create";
      const response1 = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataComp),
      });
      //si no existe devuelve response1.status === 204
      if (response1.status === 200) {
        const dataComp = await response1.json();
        let response2;
        const postData = {
          guiD_VEND: dataComp.guid,
          entitY_ID: dataComp.id,
          cedula: "",
          cedulA_RZ: "",
          obligacioneS_IESS: "",
          obligacioneS_IESS_RZ: "",
          registrO_UNICO: "",
          registrO_UNICO_RZ: "",
          referenciA_CLIENTES: "",
          referenciA_CLIENTES_RZ: "",
          certificadO_BANCARIO: "",
          declaracioN_IMP_RENTA: "",
          declaracioN_IVA: "",
          nombramientO_REPRESENTANTE_LEGAL: "",
          nombramientO_REPRESENTANTE_LEGAL_RZ: "",
          informE_RESPONSABILIDAD_SOCIAL: "",
          visioN_MISION_VALORES: "",
          estandareS_ETICOS: "",
          declaracion: "",
        };
        localUrl = baseUrl + "/api/VendDocumentation/Create";
        response2 = await fetch(localUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        });

        if (response2.status === 200) {
          const dataDoc = await response2.json();
          const postDataLogis = {
            entitY_ID: dataComp.id,
            address: "",
            province: "",
            city: "",
            postaL_CODE: "",
          };
          localUrl = baseUrl + "/api/LogisticsPostalAddress/Create";
          const response4 = await fetch(localUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postDataLogis),
          });
          if (response4.status === 200) {
            const dataLogis = await response4.json();

            const postDataContact1 = {
              guiD_VEND: dataComp.guid,
              entitY_ID: dataComp.id,
              name: "",
              area: "",
              phone: "",
              email: "",
              position: "",
              datE_CREATED: "",
              type: "0",
            };
            const postDataContact2 = {
              guiD_VEND: dataComp.guid,
              entitY_ID: dataComp.id,
              name: "",
              area: "",
              phone: "",
              email: "",
              position: "",
              datE_CREATED: "",
              type: "1",
              identification: "",
              typE_IDENTIFICATION: "",
            };
            localUrl = baseUrl + "/api/ContactPerson/Create";
            const response5 = await fetch(localUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(postDataContact1),
            });
            const response6 = await fetch(localUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(postDataContact2),
            });
            if (response5.status === 200 && response6.status === 200) {
              const dataCont1 = await response5.json();
              const dataCont2 = await response6.json();
              const respTypeContact = await iFunctionGetListTypeContact();
              const dataFull = {
                company: dataComp,
                document: dataDoc,
                contactPerson: [dataCont1, dataCont2],
                listTypeContact: respTypeContact,
                logisticsPostalAddress: dataLogis,
              };
              dispatch({
                type: VENDOR.VEND_FULL_COMPANY,
                payload: dataFull,
              });
            }
          }
        }
      }
    }
  };
  const getVendBankAccount = async () => {
    const guid = accounts[0].localAccountId;
    let localUrl = baseUrl + "/api/VendBankAccount/GetByGuid?guid=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      const respDoc = await iFunctionGetVendDocumentation("");
      const respCont = await iFunctionGetContactPerson(data.id);
      const respLogis = await iFunctionLogisticsPostalAddress(data.id);
      const respTypeContact = await iFunctionGetListTypeContact();
      console.log(respCont);
      const dataDis = {
        vendBankAccount: data,
        document: respDoc,
        listTypeContact: respTypeContact,
        contactPersonBank: respCont[0],
        logisticsPostalAddress: respLogis,
      };
      dispatch({
        type: VENDOR.VEND_FULL_BANK,
        payload: dataDis,
      });
    } else if (response.status === 204) {
      const dataComp = {
        namE_OWNER: "",
        identification: "",
        namE_BANK: "",
        nuM_ACCOUNT: "",
        typE_ACCOUNT: "",
        guiD_VEND: guid,
        swifT_CODE: "",
      };
      localUrl = baseUrl + "/api/VendBankAccount/Create";
      const response1 = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataComp),
      });
      //si no existe devuelve response1.status === 204
      if (response1.status === 200) {
        const dataComp = await response1.json();
        const postDataLogis = {
          entitY_ID: dataComp.id,
          address: "",
          province: "",
          city: "",
          postaL_CODE: "",
        };
        localUrl = baseUrl + "/api/LogisticsPostalAddress/Create";
        const response4 = await fetch(localUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postDataLogis),
        });
        if (response4.status === 200) {
          const dataLogis = await response4.json();
          const respDoc = await iFunctionGetVendDocumentation("");

          const postDataContact = {
            guiD_VEND: dataComp.guiD_VEND,
            entitY_ID: dataComp.id,
            name: "",
            area: "",
            phone: "",
            email: "",
            position: "",
            datE_CREATED: "",
            type: "2",
            identification: "",
            typE_IDENTIFICATION: "",
          };
          localUrl = baseUrl + "/api/ContactPerson/Create";
          const response5 = await fetch(localUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postDataContact),
          });
          if (response5.status === 200) {
            const dataContact = await response5.json();
            const respTypeContact = await iFunctionGetListTypeContact();

            const dataFull = {
              vendBankAccount: dataComp,
              document: respDoc,
              listTypeContact: respTypeContact,
              contactPersonBank: dataContact,
              logisticsPostalAddress: dataLogis,
            };
            dispatch({
              type: VENDOR.VEND_FULL_BANK,
              payload: dataFull,
            });
          }
        }
      }
    }
  };
  const getVendGeneralInformation = async () => {
    const guid = accounts[0].localAccountId;
    let dataGI = {};
    let dataCOW = [];
    let dataCONT = [];
    let localUrl =
      baseUrl +
      "/api/VendGeneralInformation/GetByGuid?guidPrimaryContact=" +
      guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      dataGI = await response.json();
    } else if (response.status === 204) {
      const dataGISend = {
        guiD_VEND: guid,
        diferenT_NAME: "",
        ruc: "",
        tO_DATE: new Date().toISOString().slice(0, 10).toString(),
        questioN0: "giQuestion0",
        questioN0_DESCRIPTION: "",
        questioN0_RESP: "",
        questioN1: "giQuestion1",
        questioN1_DESCRIPTION: "",
        questioN1_RESP: "",
        questioN2: "giQuestion2",
        questioN2_DESCRIPTION: "",
        questioN2_RESP: "",
        questioN3: "giQuestion3",
        questioN3_DESCRIPTION: "",
        questioN3_RESP: "",
        questioN4: "giQuestion4",
        questioN4_DESCRIPTION: "",
        questioN4_RESP: "",
        questioN5: "giQuestion5",
        questioN5_DESCRIPTION: "",
        questioN5_RESP: "",
        questioN6: "giQuestion6",
        questioN6_DESCRIPTION: "",
        questioN6_RESP: "",
        questioN7: "giQuestion7",
        questioN7_DESCRIPTION: "",
        questioN7_RESP: "",
        questioN8: "giQuestion8",
        questioN8_DESCRIPTION: "",
        questioN8_RESP: "",
        fliquestioN1: "fliQuestion1",
        fliquestioN1_DESCRIPTION: "",
        fliquestioN1_RESP: "",
        fliquestioN1_1: "fliQuestion1_1",
        fliquestioN1_1_DESCRIPTION: "",
        fliquestioN1_1_RESP: "",
        fliquestioN2: "fliQuestion2",
        fliquestioN2_DESCRIPTION: "",
        fliquestioN2_RESP: "",
        fliquestioN3: "fliQuestion3",
        fliquestioN3_DESCRIPTION: "",
        fliquestioN3_RESP: "",
        fliquestioN4: "fliQuestion4",
        fliquestioN4_DESCRIPTION: "",
        fliquestioN4_RESP: "",
      };
      const localUrl = baseUrl + "/api/VendGeneralInformation/Create";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataGISend),
      });
      //si no existe devuelve response.status === 204
      if (response.status === 200) {
        dataGI = await response.json();
      }
    }
    dataCOW = await iFunctionGetCompanyOwner();
    dataCONT = await iFunctionGetContractor();
    const dataAllGI = {
      vendGeneralInformation: dataGI,
      companyOwner: dataCOW,
      contractor: dataCONT,
    };
    dispatch({
      type: VENDOR.VEND_FULL_GENERAL_INFO,
      payload: dataAllGI,
    });
  };
  const iFunctionGetCompanyOwner = async () => {
    let resp = [];
    const guid = accounts[0].localAccountId;
    let localUrl = baseUrl + "/api/CompanyOwner?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      resp = await response.json();
    }
    return resp;
  };
  const iFunctionGetContractor = async () => {
    let resp = [];
    const guid = accounts[0].localAccountId;
    let localUrl = baseUrl + "/api/Contractor?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      resp = await response.json();
    }
    return resp;
  };
  const iFunctionGetListTypeContact = async () => {
    let resp = [];
    const localUrl = baseUrl + "/api/TypeContact";
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      resp = await response.json();
    }
    return resp;
  };
  const iFunctionGetVendDocumentation = async (entityId) => {
    let resp = {};
    const guid = accounts[0].localAccountId;
    let localUrl;
    localUrl =
      baseUrl +
      "/api/VendDocumentation/GetByGuid?guidPrimaryContact=" +
      guid +
      "&entityId=" +
      entityId;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    resp = await response.json();
    return resp;
  };
  const getVendDocumentation = async () => {
    const guid = accounts[0].localAccountId;
    let localUrl;
    localUrl =
      baseUrl +
      "/api/VendDocumentation/GetByGuid?guidPrimaryContact=" +
      guid +
      "&entityId=" +
      state.companyInformation.id;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.VEND_DOCUMENTATION,
        payload: data,
      });
    }
  };
  const getAllVendInformation = async () => {
    const guid = accounts[0].localAccountId;
    const localUrl = baseUrl + "/api/RequestBaw?guidPrimaryContact=" + guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      const respTypeContact = await iFunctionGetListTypeContact();

      console.log(data);
      const allVendInf = {
        vendorInformation: data.vendorInformation,
        companyInformation: data.companyInformation.companyInformation,
        contactPerson: data.companyInformation.contactPerson,
        logisticsPostalAddress:
          data.companyInformation.logisticsPostalAddressCompany,
        vendBankAccount: data.bankInformation.vendBankAccount,
        logisticsPostalAddressBank: data.bankInformation.logisticsPostalAddress,
        contactPersonBank: data.bankInformation.contactPersonBAnk,
        vendGeneralInformation:
          data.generalFinantialInformation.generalFinantialInformation,
        companyOwner: data.generalFinantialInformation.companyOwner,
        contractor: data.generalFinantialInformation.contractor,
        respTypeContact: respTypeContact,
      };
      console.log(allVendInf);
      dispatch({
        type: VENDOR.VEND_ALL_INFO,
        payload: allVendInf,
      });
    }
  };
  const iFunctionGetContactPerson = async (entityId) => {
    let resp = {};
    const guid = accounts[0].localAccountId;
    let localUrl;
    localUrl =
      baseUrl +
      "/api/ContactPerson/GetByGuid?guidPrimaryContact=" +
      guid +
      "&entityId=" +
      entityId;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    resp = await response.json();
    return resp;
  };
  const getContactPerson = async () => {
    const guid = accounts[0].localAccountId;
    let localUrl;
    localUrl =
      baseUrl +
      "/api/ContactPerson/GetByGuid?guidPrimaryContact=" +
      guid +
      "&entityId=" +
      state.companyInformation.id;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.CONTACT_PERSON,
        payload: data,
      });
    }
  };
  const iFunctionLogisticsPostalAddress = async (entityId) => {
    let resp = {};
    let localUrl;
    localUrl =
      baseUrl + "/api/LogisticsPostalAddress/GetByGuid?entityId=" + entityId;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    resp = await response.json();
    return resp;
  };
  const getLogisticsPostalAddress = async (entityId) => {
    let localUrl;
    localUrl =
      baseUrl + "/api/LogisticsPostalAddress/GetByGuid?entityId=" + entityId;
    const response = await fetch(localUrl);
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.LOGISTICS_POSTAL_ADDRESS,
        payload: data,
      });
    }
  };
  const getListCountry = async (company) => {
    const localUrl =
      baseUrl + "/api/VendorEnrollment/Country?company=" + company;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.LIST_COUNTRY,
        payload: data,
      });
    }
  };
  const getListProvince = async (countryId) => {
    const localUrl =
      baseUrl +
      "/api/VendorEnrollment/Province?countryId=" +
      countryId +
      "&company=" +
      state.vendorInformation.company;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.LIST_PROVINCE,
        payload: data,
      });
    }
  };
  const getListCity = async (provinceId) => {
    if (provinceId !== "") {
      const localUrl =
        baseUrl +
        "/api/VendorEnrollment/City?provinceId=" +
        provinceId +
        "&company=" +
        state.vendorInformation.company;
      const response = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response.status === 200) {
        const data = await response.json();
        dispatch({
          type: VENDOR.LIST_CITY,
          payload: data,
        });
      }
    }
  };
  const getListCityManageBank = async (provinceId) => {
    let data = [];
    if (provinceId !== "") {
      const localUrl =
        baseUrl +
        "/api/VendorEnrollment/City?provinceId=" +
        provinceId +
        "&company=" +
        state.vendorInformation.company;
      const response = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response.status === 200) {
        data = await response.json();
      }
    }
    return data;
  };
  const getListBank = async (company) => {
    const localUrl = baseUrl + "/api/VendorEnrollment/Bank?company=" + company;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.LIST_BANK,
        payload: data,
      });
    }
  };
  const getListTypeContact = async () => {
    const localUrl = baseUrl + "/api/TypeContact";
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: VENDOR.LIST_TYPE_CONTACT,
        payload: data,
      });
    }
  };
  const getVendorInformation = async (currentContact) => {
    let guidPrimary;
    if (currentContact.guiD_PRIMARY_CONTACT !== "") {
      guidPrimary = currentContact.guiD_PRIMARY_CONTACT;
    } else {
      guidPrimary = currentContact.guid;
    }
    let localUrl =
      baseUrl +
      "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimary;
    let response1 = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response1.status === 200) {
      const dataVendor = await response1.json();
      localUrl =
        baseUrl +
        "/api/VendorInformation/GetCompanyInfo?accountNum=" +
        dataVendor.ruc +
        "&guidPrimaryContact=" +
        guidPrimary +
        "&company=" +
        dataVendor.company;
      response1 = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response1.status === 200) {
        const data = await response1.json();
        const respTypeContact = await iFunctionGetListTypeContact();
        const allVendInf = {
          vendorInformation: dataVendor,
          companyInformation: data.companyInformation.companyInformation,
          contactPerson: data.companyInformation.contactPerson,
          logisticsPostalAddress:
            data.companyInformation.logisticsPostalAddressCompany,

          respTypeContact: respTypeContact,
        };
        console.log(data);
        dispatch({
          type: VENDOR.VEND_UPD_COMPANY_INFO,
          payload: allVendInf,
        });
      }
    }
  };
  const getVendorBankInformation = async (currentContact) => {
    try {
      let listBankLocal = [];
      let listProvinceLocal = [];
      let guidPrimary;
      if (currentContact.guiD_PRIMARY_CONTACT !== "") {
        guidPrimary = currentContact.guiD_PRIMARY_CONTACT;
      } else {
        guidPrimary = currentContact.guid;
      }
      let localUrl =
        baseUrl +
        "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
        guidPrimary;
      let response1 = await fetch(localUrl);
      if (response1.status === 200) {
        const dataVendor = await response1.json();
        localUrl =
          baseUrl +
          "/api/VendorInformation/GetBankInfo?accountNum=" +
          dataVendor.ruc +
          "&guidPrimaryContact=" +
          guidPrimary +
          "&company=" +
          dataVendor.company;
        response1 = await fetch(localUrl);
        if (response1.status === 200) {
          const data = await response1.json();
          const respTypeContact = await iFunctionGetListTypeContact();
          if (dataVendor.country === "ECU") {
            //recuperamos los bancos
            localUrl =
              baseUrl +
              "/api/VendorEnrollment/Bank?company=" +
              dataVendor.company;
            let response = await fetch(localUrl);
            if (response.status === 200) {
              listBankLocal = await response.json();
            }
            //recuperamos las provincias
            localUrl =
              baseUrl +
              "/api/VendorEnrollment/Province?countryId=" +
              dataVendor.country +
              "&company=" +
              dataVendor.company;
            response = await fetch(localUrl);
            if (response.status === 200) {
              listProvinceLocal = await response.json();
            }
            //recuperamos las ciudades
            for (let i = 0; i < data.bankInformationList.length; i++) {
              if (data.bankInformationList[i].logisticsPostalAddress) {
                if (
                  data.bankInformationList[i].logisticsPostalAddress
                    .province !== ""
                ) {
                  localUrl =
                    baseUrl +
                    "/api/VendorEnrollment/City?provinceId=" +
                    data.bankInformationList[i].logisticsPostalAddress
                      .province +
                    "&company=" +
                    dataVendor.company;
                  response = await fetch(localUrl);
                  if (response.status === 200) {
                    data.bankInformationList[i]["listCityLogistics"] =
                      await response.json();
                  }
                }
              }
            }
          }
          console.log(data);
          const allVendInf = {
            vendorInformation: dataVendor,
            vendBankAccount: data.bankInformation.vendBankAccount,
            bankInformationList: data.bankInformationList,
            logisticsPostalAddressBank:
              data.bankInformation.logisticsPostalAddress,
            contactPersonBank: data.bankInformation.contactPersonBAnk,
            respTypeContact: respTypeContact,
            listProvince: listProvinceLocal,
            listBank: listBankLocal,
          };
          dispatch({
            type: VENDOR.VEND_UPD_BANK_INFO,
            payload: allVendInf,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getVendorUpdGeneralInformation = async (currentContact) => {
    let guidPrimary;
    if (currentContact.guiD_PRIMARY_CONTACT !== "") {
      guidPrimary = currentContact.guiD_PRIMARY_CONTACT;
    } else {
      guidPrimary = currentContact.guid;
    }
    let localUrl =
      baseUrl +
      "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimary;
    let response1 = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response1.status === 200) {
      const dataVendor = await response1.json();
      localUrl =
        baseUrl +
        "/api/VendorInformation/GetGeneralInfo?guidPrimaryContact=" +
        guidPrimary;
      response1 = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response1.status === 200) {
        const data = await response1.json();
        const respTypeContact = await iFunctionGetListTypeContact();
        const allVendInf = {
          vendorInformation: dataVendor,
          vendGeneralInformation: data.vendGeneralInformation,
          companyOwner: data.companyOwner,
          contractor: data.contractor,
          respTypeContact: respTypeContact,
        };
        console.log(allVendInf);
        dispatch({
          type: VENDOR.VEND_UPD_GENERAL_INFO,
          payload: allVendInf,
        });
      }
    }
  };
  const sendVendorAXLogisticsAddress = async (postData) => {
    let resp = false;
    let localUrl = baseUrl + "/api/VendorInformation/LogisticsPostalAddress";
    let response1 = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response1.status === 200) {
      resp = true;
    }
    return resp;
  };
  const sendContactPersonArr = async (data) => {
    const localUrl = baseUrl + "/api/ContactPerson/Update";
    for (let i = 0; i < data.length; i++) {
      const postData = data[i];
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });
      const resp = await iFunctionGetContactPerson(postData.entitY_ID);
      dispatch({
        type: VENDOR.CONTACT_PERSON,
        payload: resp,
      });
    }
  };
  const sendVendorAXContactPerson = async (postData, accountNum, company) => {
    let resp = false;
    let localUrl =
      baseUrl +
      "/api/VendorInformation/CreateOrUpdateVendContactInfo?accountNum=" +
      accountNum +
      "&company=" +
      company;
    let response1 = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response1.status === 200) {
      resp = true;
    }
    return resp;
  };
  const sendVendorAXContactPersonRepPurch = async (
    postData,
    accountNum,
    company
  ) => {
    let resp = false;
    let localUrl =
      baseUrl +
      "/api/VendorInformation/CreateOrUpdateContactRepPurch?accountNum=" +
      accountNum +
      "&company=" +
      company;
    let response1 = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response1.status === 200) {
      resp = true;
    }
    return resp;
  };
  const getVendorUpdDocumentation = async (currentContact) => {
    let guidPrimary;
    if (currentContact.guiD_PRIMARY_CONTACT !== "") {
      guidPrimary = currentContact.guiD_PRIMARY_CONTACT;
    } else {
      guidPrimary = currentContact.guid;
    }
    let localUrl =
      baseUrl +
      "/api/CompanyInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimary;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const datacompanyInformation = await response.json();
      localUrl =
        baseUrl +
        "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
        guidPrimary;
      let response1 = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response1.status === 200) {
        const dataVendor = await response1.json();
        localUrl =
          baseUrl +
          "/api/VendorInformation/GetDocumentationInfo?guidPrimaryContact=" +
          guidPrimary +
          "&company=" +
          dataVendor.company;
        response1 = await fetch(localUrl);
        //si no existe devuelve response.status === 204
        if (response1.status === 200) {
          const data = await response1.json();
          console.log(data);
          const allVendInf = {
            vendorInformation: dataVendor,
            vendDocumentation: data,
            companyInformation: datacompanyInformation,
          };

          dispatch({
            type: VENDOR.VEND_UPD_DOCUMENTATION,
            payload: allVendInf,
          });
        }
      }
    }
  };
  const createVendBank = async (data) => {
    try {
      const localUrl = baseUrl + "/api/VendBankAccount/Create";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response.status === 200) {
        const resp = await response.json();
        return resp;
      }
      return null;
    } catch (error) {
      console.log(error);
    }
  };
  const createContactPerson = async (data) => {
    try {
      const localUrl = baseUrl + "/api/ContactPerson/Create";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response.status === 200) {
        const resp = await response.json();
        return resp;
      }
      return null;
    } catch (error) {
      console.log(error);
    }
  };
  const createLogisticsPostalAddress = async (data) => {
    try {
      const localUrl = baseUrl + "/api/LogisticsPostalAddress/Create";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response.status === 200) {
        const resp = await response.json();
        return resp;
      }
      return null;
    } catch (error) {
      console.log(error);
    }
  };
  const createVendDocumentation = async (data) => {
    const postData = data;
    const localUrl = baseUrl + "/api/VendDocumentation/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    return null;
  };
  const createVendBankDocumentation = async (data) => {
    try {
      console.log(data);
      const postData = data;
      const localUrl = baseUrl + "/api/VendDocumentation/Bank/CreateOrUpdate";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });
      if (response.status === 200) {
        const resp = await response.json();
        return resp;
      }
      return null;
    } catch (error) {
      alert(error);
    }
  };
  const sendBankCertificateApproval = async (data) => {
    data["approvaL_STATUS"] = false;
    let localUrl = baseUrl + "/api/VendBankAccount/Approved";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    return null;
  };
  const sendBankInformationAX = async (data, company) => {
    const localUrl =
      baseUrl + "/api/VendBankAccount/UpdateAX?company=" + company;
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      return true;
    }
    return false;
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <VendorContext.Provider
      value={{
        activeStep: state.activeStep,
        steps: state.steps,
        vendFlowEnrollment: state.vendFlowEnrollment,
        vendorInformation: state.vendorInformation,
        companyInformation: state.companyInformation,
        vendBankAccount: state.vendBankAccount,
        bankInformationList: state.bankInformationList,
        contactPersonBank: state.contactPersonBank,
        vendDocumentation: state.vendDocumentation,
        contactPerson: state.contactPerson,
        logisticsPostalAddress: state.logisticsPostalAddress,
        logisticsPostalAddressBank: state.logisticsPostalAddressBank,
        vendGeneralInformation: state.vendGeneralInformation,
        companyOwner: state.companyOwner,
        contractor: state.contractor,
        listCountry: state.listCountry,
        listProvince: state.listProvince,
        listCity: state.listCity,
        listBank: state.listBank,
        listTypeContact: state.listTypeContact,
        setActiveStep,
        setContactPerson,
        setContactPersonBank,
        setBankInformationList,
        setVendFlowEnrollment,
        setVendorInformation,
        setCompanyInformation,
        setVendDocumentation,
        setVendBankAccount,
        setLogisticsPostalAddress,
        setVendGeneralInformation,
        setCompanyOwner,
        setContractor,
        getVendFlowEnrollment,
        getCompanyInformation,
        getVendorInformation,
        getVendorBankInformation,
        getVendorUpdGeneralInformation,
        getVendorUpdDocumentation,
        getVendDocumentation,
        getContactPerson,
        getVendBankAccount,
        getDataEnrollment,
        getLogisticsPostalAddress,
        getVendGeneralInformation,
        getAllVendInformation,
        sendVendFlowEnrollment,
        sendVendorInformation,
        sendCompanyInformation,
        sendVendDocumentation,
        sendContactPerson,
        sendVendBankAccount,
        sendVendDocumentationAX,
        createVendBank,
        createContactPerson,
        createLogisticsPostalAddress,
        createVendDocumentation,
        createVendBankDocumentation,
        sendLogisticsPostalAddress,
        sendVendGeneralInformation,
        sendCompanyOwner,
        sendContractor,
        sendVendorInformationStatement,
        sendVendorAXLogisticsAddress,
        sendVendorAXContactPerson,
        sendContactPersonArr,
        sendVendorAXContactPersonRepPurch,
        sendBankCertificateApproval,
        sendBankInformationAX,
        getSteps,
        getListCountry,
        getListProvince,
        getListCity,
        getListCityManageBank,
        getListBank,
        getListTypeContact,
        getBase64,
      }}
    >
      {props.children}
    </VendorContext.Provider>
  );
};

export default VendorState;
